import React from "react";
import { PropertiesMap } from "./PropertiesMap";

export const EncasaMap  = () => {
  return (<div className="">
    <div className="section-container">
      {/* <MapView /> */}
      <PropertiesMap />
    </div>
  </div>);
};